var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkFormvkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_615_607)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.4165 7.04149C5.64912 7.35247 5.94591 7.60979 6.28672 7.79599C6.62753 7.9822 7.0044 8.09292 7.39177 8.12067C7.77914 8.14841 8.16795 8.09252 8.53182 7.95678C8.89569 7.82105 9.22611 7.60865 9.50067 7.33399L11.1257 5.70899C11.619 5.19819 11.892 4.51406 11.8858 3.80394C11.8797 3.09382 11.5948 2.41454 11.0927 1.91239C10.5905 1.41025 9.91125 1.12541 9.20113 1.11924C8.49102 1.11307 7.80689 1.38606 7.29609 1.8794L6.36442 2.80565",
    stroke: "#FFC0F6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5832 5.95817C7.35058 5.64718 7.0538 5.38986 6.71298 5.20366C6.37217 5.01746 5.9953 4.90673 5.60793 4.87899C5.22056 4.85125 4.83175 4.90714 4.46789 5.04287C4.10402 5.17861 3.77359 5.39101 3.49903 5.66567L1.87403 7.29067C1.38069 7.80147 1.1077 8.4856 1.11387 9.19572C1.12004 9.90583 1.40488 10.5851 1.90702 11.0873C2.40917 11.5894 3.08845 11.8742 3.79857 11.8804C4.50869 11.8866 5.19282 11.6136 5.70361 11.1203L6.62986 10.194",
    stroke: "#FFC0F6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_615_607"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkFormvkIcon);
export default __webpack_public_path__ + "static/media/link-formvk-icon.c36b0a9413e394779eabba055c9da1af.svg";
export { ForwardRef as ReactComponent };